/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ActivatePhysicalCardRequest,
  ActivateReplacedPhysicalCardRequest,
  AllowedCardTypesDto,
  CardAccountingAttributesRequest,
  CardChangeLogDto,
  CardOrderResponse,
  CardResponse,
  CardSlim,
  CardUsageRequest,
  CardUsageResponse,
  CheckAllowedCardTypeDto,
  CreateBulkCardsRequest,
  CreateCardRequest,
  CsvDownloadCardFilterRequest,
  FileAttachmentDto,
  FindCardChangeLogsByCardIdParams,
  FindCardsRequestDto,
  GetCardParams,
  GetSubscriptionFileUploadedParams,
  OneTimeTokenResponse,
  PageCardResponse,
  ReorderCustomShippingAddressRequest,
  ReorderPhysicalCardRequest,
  SpendNotificationSettingsDto,
  ThreeDsAuthenticationConfirmation,
  UpdateCardStatusRequest,
  UploadSubscriptionMigrationFileParams,
  UploadSubscriptionMigrationFilePayload,
  VirtualCardDetailsTokenResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCardsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cards-controller
   * @name UpdateCardStatus
   * @request PUT:/api/v1/user/{userId}/card/{cardId}
   */
  updateCardStatus = (
    userId: string,
    cardId: string,
    data: UpdateCardStatusRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/user/${userId}/card/${cardId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateCardStatusPath = '/v1/user/${userId}/card/${cardId}'
  static updateCardStatusMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ActivateVirtualCardForUser
   * @request PUT:/api/v1/user/{userId}/card/virtual/{cardId}/active
   */
  activateVirtualCardForUser = (userId: string, cardId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/user/${userId}/card/virtual/${cardId}/active`,
      method: 'PUT',
      ...params,
    })

  static activateVirtualCardForUserPath = '/v1/user/${userId}/card/virtual/${cardId}/active'
  static activateVirtualCardForUserMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name SaveCardAccountingAttributes
   * @request PUT:/api/v1/cards/accounting-attributes
   */
  saveCardAccountingAttributes = (
    data: CardAccountingAttributesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CardResponse, any>({
      path: `/v1/cards/accounting-attributes`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static saveCardAccountingAttributesPath = '/v1/cards/accounting-attributes'
  static saveCardAccountingAttributesMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetCard
   * @request GET:/api/v1/card/{cardId}
   * @deprecated
   */
  getCard = ({ cardId, ...query }: GetCardParams, params: RequestParams = {}) =>
    this.http.request<CardResponse, any>({
      path: `/v1/card/${cardId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCardPath = '/v1/card/${cardId}'
  static getCardMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name UpdateCardStatusDeprecated
   * @request PUT:/api/v1/card/{cardId}
   * @deprecated
   */
  updateCardStatusDeprecated = (
    cardId: string,
    data: UpdateCardStatusRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/card/${cardId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateCardStatusDeprecatedPath = '/v1/card/${cardId}'
  static updateCardStatusDeprecatedMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ActivateVirtualCard
   * @request PUT:/api/v1/card/virtual/{cardId}/active
   */
  activateVirtualCard = (cardId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/card/virtual/${cardId}/active`,
      method: 'PUT',
      ...params,
    })

  static activateVirtualCardPath = '/v1/card/virtual/${cardId}/active'
  static activateVirtualCardMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name CreateBulkCards1
   * @request POST:/api/v1/users/bulk-cards
   * @deprecated
   */
  createBulkCards = (data: CreateBulkCardsRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse[], any>({
      path: `/v1/users/bulk-cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBulkCardsPath = '/v1/users/bulk-cards'
  static createBulkCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name CreateCard1
   * @request POST:/api/v1/user/{userId}/card
   */
  createCard = (userId: string, data: CreateCardRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse, any>({
      path: `/v1/user/${userId}/card`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCardPath = '/v1/user/${userId}/card'
  static createCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetTeamCardsPaged
   * @request POST:/api/v1/team/cards/paged
   */
  getTeamCardsPaged = (data: FindCardsRequestDto, params: RequestParams = {}) =>
    this.http.request<PageCardResponse, any>({
      path: `/v1/team/cards/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getTeamCardsPagedPath = '/v1/team/cards/paged'
  static getTeamCardsPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetOrganisationCardsPagedPost
   * @request POST:/api/v1/organisation/cards
   */
  getOrganisationCardsPagedPost = (data: FindCardsRequestDto, params: RequestParams = {}) =>
    this.http.request<PageCardResponse, any>({
      path: `/v1/organisation/cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getOrganisationCardsPagedPostPath = '/v1/organisation/cards'
  static getOrganisationCardsPagedPostMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetByCardId
   * @request GET:/api/v1/cards/{cardId}/notifications/spend-limit
   */
  getByCardId = (cardId: string, params: RequestParams = {}) =>
    this.http.request<SpendNotificationSettingsDto, any>({
      path: `/v1/cards/${cardId}/notifications/spend-limit`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByCardIdPath = '/v1/cards/${cardId}/notifications/spend-limit'
  static getByCardIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name UpdateSpendNotificationsSettings
   * @request POST:/api/v1/cards/{cardId}/notifications/spend-limit
   */
  updateSpendNotificationsSettings = (
    cardId: string,
    data: SpendNotificationSettingsDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/cards/${cardId}/notifications/spend-limit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateSpendNotificationsSettingsPath = '/v1/cards/${cardId}/notifications/spend-limit'
  static updateSpendNotificationsSettingsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetCardsUsage
   * @request POST:/api/v1/cards/usage
   */
  getCardsUsage = (data: CardUsageRequest, params: RequestParams = {}) =>
    this.http.request<CardUsageResponse, any>({
      path: `/v1/cards/usage`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getCardsUsagePath = '/v1/cards/usage'
  static getCardsUsageMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ConfirmThreeDsTxAuthentication
   * @request POST:/api/v1/cards/transactions/authentication/confirm
   */
  confirmThreeDsTxAuthentication = (
    data: ThreeDsAuthenticationConfirmation,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/cards/transactions/authentication/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static confirmThreeDsTxAuthenticationPath = '/v1/cards/transactions/authentication/confirm'
  static confirmThreeDsTxAuthenticationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name UploadSubscriptionMigrationFile
   * @request POST:/api/v1/cards/subscription/migration-file
   */
  uploadSubscriptionMigrationFile = (
    query: UploadSubscriptionMigrationFileParams,
    data: UploadSubscriptionMigrationFilePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FileAttachmentDto, any>({
      path: `/v1/cards/subscription/migration-file`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadSubscriptionMigrationFilePath = '/v1/cards/subscription/migration-file'
  static uploadSubscriptionMigrationFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetUserCardsPaginated
   * @request POST:/api/v1/cards/paged
   */
  getUserCardsPaginated = (data: FindCardsRequestDto, params: RequestParams = {}) =>
    this.http.request<PageCardResponse, any>({
      path: `/v1/cards/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserCardsPaginatedPath = '/v1/cards/paged'
  static getUserCardsPaginatedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name DownloadCsv1
   * @request POST:/api/v1/cards/download/csv
   */
  downloadCsv = (data: CsvDownloadCardFilterRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/cards/download/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadCsvPath = '/v1/cards/download/csv'
  static downloadCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ReissueVirtualCard
   * @request POST:/api/v1/card/virtual/{cardId}/reissue
   */
  reissueVirtualCard = (cardId: string, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse, any>({
      path: `/v1/card/virtual/${cardId}/reissue`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static reissueVirtualCardPath = '/v1/card/virtual/${cardId}/reissue'
  static reissueVirtualCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ReorderPhysicalCard
   * @request POST:/api/v1/card/reorder
   */
  reorderPhysicalCard = (data: ReorderPhysicalCardRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse, any>({
      path: `/v1/card/reorder`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static reorderPhysicalCardPath = '/v1/card/reorder'
  static reorderPhysicalCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name SaveShippingAddressForPhysicalCardReorder
   * @request POST:/api/v1/card/physical/reorder/shipping-address
   */
  saveShippingAddressForPhysicalCardReorder = (
    data: ReorderCustomShippingAddressRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CardResponse, any>({
      path: `/v1/card/physical/reorder/shipping-address`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static saveShippingAddressForPhysicalCardReorderPath =
    '/v1/card/physical/reorder/shipping-address'
  static saveShippingAddressForPhysicalCardReorderMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ActivatePhysicalCard
   * @request POST:/api/v1/card/physical/active
   */
  activatePhysicalCard = (data: ActivatePhysicalCardRequest, params: RequestParams = {}) =>
    this.http.request<CardResponse, any>({
      path: `/v1/card/physical/active`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static activatePhysicalCardPath = '/v1/card/physical/active'
  static activatePhysicalCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name VerifyLastFourDigitsForPhysicalCard
   * @request POST:/api/v1/card/physical/active/verify-last-four-digits
   */
  verifyLastFourDigitsForPhysicalCard = (
    data: ActivatePhysicalCardRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CardResponse, any>({
      path: `/v1/card/physical/active/verify-last-four-digits`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static verifyLastFourDigitsForPhysicalCardPath =
    '/v1/card/physical/active/verify-last-four-digits'
  static verifyLastFourDigitsForPhysicalCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name ActivateReplacedPhysicalCard
   * @request POST:/api/v1/card/physical/active/replacement
   */
  activateReplacedPhysicalCard = (
    data: ActivateReplacedPhysicalCardRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CardResponse, any>({
      path: `/v1/card/physical/active/replacement`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static activateReplacedPhysicalCardPath = '/v1/card/physical/active/replacement'
  static activateReplacedPhysicalCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetSubscriptionFileUploaded
   * @request GET:/api/v1/cards/subscription/migration-file/uploaded
   */
  getSubscriptionFileUploaded = (
    query: GetSubscriptionFileUploadedParams,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/v1/cards/subscription/migration-file/uploaded`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSubscriptionFileUploadedPath = '/v1/cards/subscription/migration-file/uploaded'
  static getSubscriptionFileUploadedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetCardsSlim
   * @request GET:/api/v1/cards/slim
   */
  getCardsSlim = (params: RequestParams = {}) =>
    this.http.request<CardSlim[], any>({
      path: `/v1/cards/slim`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCardsSlimPath = '/v1/cards/slim'
  static getCardsSlimMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetAllowedCardTypes
   * @request GET:/api/v1/cards/allowed-card-types
   */
  getAllowedCardTypes = (params: RequestParams = {}) =>
    this.http.request<AllowedCardTypesDto, any>({
      path: `/v1/cards/allowed-card-types`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllowedCardTypesPath = '/v1/cards/allowed-card-types'
  static getAllowedCardTypesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetAllowedCardTypesByTypesForUser
   * @request GET:/api/v1/cards/allowed-card-types/{requestedCardType}/users/{userId}
   */
  getAllowedCardTypesByTypesForUser = (
    requestedCardType: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<CheckAllowedCardTypeDto, any>({
      path: `/v1/cards/allowed-card-types/${requestedCardType}/users/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllowedCardTypesByTypesForUserPath =
    '/v1/cards/allowed-card-types/${requestedCardType}/users/${userId}'
  static getAllowedCardTypesByTypesForUserMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name FindCardChangeLogsByCardId
   * @request GET:/api/v1/card/{cardId}/card-change-log
   */
  findCardChangeLogsByCardId = (
    { cardId, ...query }: FindCardChangeLogsByCardIdParams,
    params: RequestParams = {},
  ) =>
    this.http.request<CardChangeLogDto[], any>({
      path: `/v1/card/${cardId}/card-change-log`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findCardChangeLogsByCardIdPath = '/v1/card/${cardId}/card-change-log'
  static findCardChangeLogsByCardIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetVirtualPanPreviewToken
   * @request GET:/api/v1/card/virtual/{cardId}/details-token
   */
  getVirtualPanPreviewToken = (cardId: string, params: RequestParams = {}) =>
    this.http.request<VirtualCardDetailsTokenResponse, any>({
      path: `/v1/card/virtual/${cardId}/details-token`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVirtualPanPreviewTokenPath = '/v1/card/virtual/${cardId}/details-token'
  static getVirtualPanPreviewTokenMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetVirtualPanPreviewWithCategoryToken
   * @request GET:/api/v1/card/virtual/{cardId}/details-token/{riskCategory}
   */
  getVirtualPanPreviewWithCategoryToken = (
    cardId: string,
    riskCategory: 'LOW' | 'MID' | 'HIGH',
    params: RequestParams = {},
  ) =>
    this.http.request<VirtualCardDetailsTokenResponse, any>({
      path: `/v1/card/virtual/${cardId}/details-token/${riskCategory}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVirtualPanPreviewWithCategoryTokenPath =
    '/v1/card/virtual/${cardId}/details-token/${riskCategory}'
  static getVirtualPanPreviewWithCategoryTokenMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-controller
   * @name GetPhysicalCardOneTimeToken
   * @request GET:/api/v1/card/physical/one-time-token
   */
  getPhysicalCardOneTimeToken = (params: RequestParams = {}) =>
    this.http.request<OneTimeTokenResponse, any>({
      path: `/v1/card/physical/one-time-token`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPhysicalCardOneTimeTokenPath = '/v1/card/physical/one-time-token'
  static getPhysicalCardOneTimeTokenMethod = 'GET'
}
